module.exports = __webpack_public_path__ + "static/media/erica_song.c10f3d8a.png";